"use strict";
export { CardBody as Body, CardDescription as Description, CardFooter as Footer, CardHeader as Header, CardPropsProvider as PropsProvider, CardRoot as Root, CardTitle as Title } from './card.js';
